'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _x = require('-!svg-react-loader!../../../assets/images/change-provider/x2.svg');

var _x2 = _interopRequireDefault(_x);

var _chooseProviderCloseButton = require('./chooseProviderCloseButton.scss');

var _chooseProviderCloseButton2 = _interopRequireDefault(_chooseProviderCloseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChooseProviderCloseButton = function ChooseProviderCloseButton(props) {
  var onClick = props.onClick;


  return _react2.default.createElement(
    'div',
    { onClick: onClick, className: _chooseProviderCloseButton2.default.close },
    (0, _x2.default)({ width: '24', height: '24', viewBox: '0 0 24 24' })
  );
};

ChooseProviderCloseButton.propTypes = {
  onClick: _propTypes2.default.func
};

ChooseProviderCloseButton.propTypes = {};

exports.default = ChooseProviderCloseButton;